const { REACT_APP_PROJECT_NAME = "tempProject" } = process.env;

// GLOBAL
export const GLOBAL_BLOCK_UI = `@GLOBAL/BLOCK`;
export const GLOBAL_RELEASE_UI = `@GLOBAL/RELEASE_UI`;

// Auth
export const AUTH_ERROR = "AUTH/ERROR";
export const AUTH_TOKEN = "AUTH/SAVE_API_TOKEN";
export const USER_TOKEN_NAME = `${REACT_APP_PROJECT_NAME}AuthToken`;
export const ADMIN_TOKEN_NAME = `${REACT_APP_PROJECT_NAME}AuthToken_ADMIN`;

// User
export const USER_LOADING = "USER/LOADING";
export const SSO_USER = "USER/SSO";
export const SSO_COMPLETE = "USER/SSO_COMPLETE";
export const REGISTER_USER = "USER/REGISTER";
export const LOGIN_USER = "USER/LOGIN";
export const LOAD_USER = "USER/LOAD";
export const REFRESH_USER = "USER/REFRESH";
export const UPDATE_USER = "USER/UPDATE";
export const LOGOUT_USER = "USER/LOGOUT";
export const RESET_USER = "USER/RESET";
export const LIST_USER = "USER/LIST";
export const LIST_USER_ERROR = "USER/LIST_ERROR";

// Account
export const ACCOUNT_ERROR = "ACCOUNT/ERROR";
export const LOADING_ACCOUNT = "ACCOUNT/LOADING";
export const SET_ACCOUNT = "ACCOUNT/SET";
export const SET_ACCOUNT_STATUS = "ACCOUNT/SET_STATUS";

// Contact Methods
export const CONTACT_METHOD_ERROR = "CONTACT_METHODS/ERROR";
export const SET_CONTACT_METHODS = "CONTACT_METHODS/SET";
export const ADD_CONTACT_METHOD = "CONTACT_METHODS/ADD";
export const UPDATE_CONTACT_METHOD = "CONTACT_METHODS/UPDATE";
export const REMOVE_CONTACT_METHOD = "CONTACT_METHODS/REMOVE";
export const GET_CONTACT_METHOD = "CONTACT_METHODS/GET";
export const LIST_CONTACT_METHOD = "CONTACT_METHODS/LIST";

// Account Preferences
export const PREFERENCE_ERROR = "PREFERENCE/ERROR";
export const SET_PREFERENCES = "PREFERENCES/SET";
export const GET_PREFERENCES = "PREFERENCES/GET";
export const REMOVE_PREFERENCE = "PREFERENCE/REMOVE";
export const UPDATE_PREFERENCE = "PREFERENCE/UPDATE";
export const LIST_PREFERENCES = "PREFERENCE/LIST";

// Settings
export const THEME_CHANGED = "SETTINGS/THEME_CHANGED";

// Search
export const SET_SEARCH = "SEARCH/SET";
export const CLEAR_SEARCH = "SEARCH/CLEAR";

// Templates
export const SET_TEMPLATES = "TEMPLATES/SET";
export const LOADING_TEMPLATES = "TEMPLATES/LOADING";
export const ERROR_TEMPLATES = "TEMPLATES/ERROR";

// Active Settings
export const SET_ACTIVE_ACCOUNT = "ACTIVE/SET_ACCOUNT";
export const SET_ACTIVE_MESSAGES = "ACTIVE/SET_MESSAGES";
export const ACTIVE_ERROR = "ACTIVE/ERROR";
export const CLEAR_ACTIVE_MESSAGES = "ACTIVE/CLEAR_MESSAGES";
export const SET_AUDIT_LOG = "ACTIVE/SET_AUDIT_LOG";
export const CLEAR_ACTIVE_AUDIT_LOG = "ACTIVE/CLEAR_AUDIT";
export const SET_NOTES = "ACTIVE/SET_NOTES";
export const CLEAR_NOTES = "ACTIVE/CLEAR_NOTES";
export const ADD_NOTE = "ACTIVE/ADD_NOTE";
export const CLEAR_ACTIVE_ACCOUNT_TYPE = "ACTIVE/CLEAR_ACTIVE_ACCOUNT_TYPE";

// Messaging
export const MESSAGING_ERROR = "MESSAGING/ERROR";
export const MESSAGING_LOADING = "MESSAGING/LOADING";
export const SET_EXCLUSIONS = "MESSAGING/SET_EXCLUSIONS";

// Reports
export const ERROR_REPORT = "REPORTS/ERROR";
export const LOADING_REPORT = "REPORTS/LOADING";
export const PUT_REPORT = "REPORTS/PUT";
export const POST_REPORT = "REPORTS/POST";
export const DELETE_REPORT = "REPORTS/DELETE";
export const GET_REPORT = "REPORTS/GET";
export const LIST_REPORT = "REPORTS/LIST";
export const GET_REPORT_DATA = "REPORTS/GET_DATA";

// Notifications
export const AUTH_ERROR_TITLE = "Unauthorized";
export const AUTH_ERROR_MSG = "Session expired, please login again to continue.";

// Domain
export const DOMAIN_ERROR_TITLE = "Domain Error";
export const DOMAIN_ERROR_MSG = "There was a problem loading the domain for CPP, please try again.";

// Tenants
export const TENANTS_LOADING = "TENANTS/LOADING";
export const SET_TENANTS = "TENANTS/SET";
export const TENANT_LOAD_ERROR = "Tenant List Error";

// CPP
export const CPP_LOADING = "CPP/LOADING";
export const LOAD_CPP = "CPP/LIST";
export const CPP_ERROR = "CPP/ERROR";
export const SET_CPP = "CPP/SET";
export const CPP_ERROR_TITLE = "Sorry";
export const CPP_ERROR_MSG = "There was a problem retrieving CPP information";
export const CPP_SESSION = `${REACT_APP_PROJECT_NAME}CPP_Session`;
export const SET_CPP_CONFIG = "CPP/SET_CONFIG";
export const CONFIG_ERROR = "CPP/CONFIG_ERROR";
export const CONFIG_ERROR_TITLE = "Config Error";
export const CONFIG_ERROR_MSG = "Error retrieving config for CPP";
